import React from 'react';
import { LEGEND } from './lifecycleModel';
import { TONE_DOT } from './LifecycleTrail';

/**
 * What the dots on the Home trail mean, once, above the rows. The words say it; the colour only
 * reinforces it (the same rule StatusBadge follows). The list is `LEGEND`, which a test checks against
 * `toneForStatus`, so this key cannot drift from the colours the boxes really use.
 */
const LifecycleLegend: React.FC = () => (
  <div
    role="group"
    aria-label="What the dots mean"
    className="flex flex-wrap items-center gap-x-5 gap-y-1 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-600"
  >
    {LEGEND.map((entry) => (
      <span key={entry.tone} className="inline-flex items-center gap-1.5">
        <span aria-hidden="true" className={`h-2 w-2 shrink-0 rounded-full ${TONE_DOT[entry.tone]}`} />
        {entry.label}
      </span>
    ))}
    <span className="inline-flex items-center gap-1.5">
      <span aria-hidden="true" className="rounded-full bg-primary-600 px-1.5 text-xs font-bold leading-[16px] text-white">
        2
      </span>
      Several records: press to pick one
    </span>
    <span className="inline-flex items-center gap-1.5">
      <span className="font-medium text-slate-400">Not started</span>
      means nothing created yet
    </span>
  </div>
);

export default LifecycleLegend;
